<template>
  <span></span>
</template>
<script>
export default {
  data() {
    return {
      time: 60
    }
  },
  computed: {
    isAdmin() {
      return this.$route.path.startsWith("/admin");
    }
  },
  created() {
    let timerId = setInterval(() => {
      this.time -= 1;
      if (!this.$store.state.idleVue.isIdle) clearInterval(timerId);
      if (this.time < 1) {
        // Your logout function should be over here
        //alert('logout user....');
        this.$store.commit("SET_USERINFO", {});
        if (this.$route.name !== 'Login' && this.$route.name !== 'AdminLogin') {
          if (this.isAdmin) {
            localStorage.setItem("adminUserInfo", null);
            this.$router.push({
              name: "AdminLogin",// 管理者ログイン画面に遷移
            });
          } else {
            localStorage.setItem("userInfo", null);
            this.$router.push({
              name: "Login",// 利用者ログイン画面に遷移
            });
          }
        }
        clearInterval(timerId);
      }
    }, 60000);
  }
};
</script>